import { render, staticRenderFns } from "./NewDestinationModal.vue?vue&type=template&id=f954e8c0&lang=pug&"
import script from "./NewDestinationModal.vue?vue&type=script&lang=js&"
export * from "./NewDestinationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports